<template>
  <!-- Layout utilizado para versão horizontal ou horizontal/vertical mobile  -->
  <v-container
    v-if="
      (products && products.products && settings.layout === 'horizontal') ||
      (products && !$vuetify.breakpoint.mdAndUp && settings.layout !== 'form' && settings.layout !== 'custom')
    "
    class="mb-12"
    style="overflow: auto"
    fill-height
  >
    <v-row no-gutters justify="center" align="center">
      <v-col
        v-for="(item, i) in products.products"
        :key="i"
        :class="settings['text-color']"
        cols="12"
        align="center"
      >
        <v-card
          elevation="0"
          :max-width="$vuetify.breakpoint.mdAndUp ? '900' : ''"
          :max-height="$vuetify.breakpoint.mdAndUp ? '400' : ''"
          :min-height="$vuetify.breakpoint.mdAndUp ? '105px' : ''"
          class="mt-3 mx-2"
          :color="settings['item-background-color']"
        >
          <v-row
            :class="
              $vuetify.breakpoint.mdAndUp
                ? item.observacoes
                  ? 'pt-7'
                  : 'pt-8'
                : 'pt-5'
            "
            align="center"
            no-gutters
          >
            <v-col
              class="px-6"
              align="start"
              :cols="$vuetify.breakpoint.mdAndUp ? '8' : '12'"
            >
              <b class="black--text">{{ item.nome }} - {{ item.nome_tipo }}</b>
              <br />
              <v-row align="center" no-gutters>
                <b v-if="$vuetify.breakpoint.mdAndUp" class="description">
                  {{
                    item.observacoes
                      ? item.observacoes.length >= 50
                        ? `${item.observacoes.slice(0, 50)}...`
                        : item.observacoes
                      : ""
                  }}
                </b>
                <b v-else class="description">
                  {{item.observacoes ? item.observacoes : ""}}
                </b>
                <dialog-ticket
                  class="ml-2"
                  v-if="$vuetify.breakpoint.mdAndUp && item.observacoes && item.observacoes.length >= 50"
                  :item="item"
                />
              </v-row>
            </v-col>
            <v-col
              :class="$vuetify.breakpoint.mdAndUp ? '' : 'mt-3 pb-5'"
              :cols="$vuetify.breakpoint.mdAndUp ? '4' : '12'"
              align="end"
            >
              <v-row
                no-gutters
                :justify="$vuetify.breakpoint.mdAndUp ? 'end' : 'space-between'"
                :class="$vuetify.breakpoint.mdAndUp ? '' : 'pl-6'"
                align="center"
              >
                <b
                  v-show="!item.encerrado"
                  class="black--text"
                  :class="alignHorizontal || !$vuetify.breakpoint.mdAndUp ? 'mr-4 price' : 'price'"
                >
                  {{
                    item.valor + item.valor_conveniencia
                      ? `R$ ${(item.valor + item.valor_conveniencia)
                          .toFixed(2)
                          .replace(".", ",")}`
                      : "Grátis"
                  }}
                </b>
                <v-btn
                  dark
                  elevation="0"
                  :style="
                    `
                    background-color: ${MIXIN_getStyle(settings, 'button', 'background-color')} !important;
                    border-radius: ${MIXIN_getStyle(settings, 'button', 'border-radius')} !important
                    `
                  "
                  class="mr-6"
                  @click="openCheckout(item)"
                  :readonly="!!item.encerrado"
                >
                  <b
                    :style="
                      `
                      color: ${MIXIN_getStyle(settings, 'button', 'color')} !important;
                      `
                    "
                    >
                    {{item.encerrado ? "Encerrado" : item.valor + item.valor_conveniencia ?  "Comprar" : "Fazer Inscrição"}}
                  </b>
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { GetLayoutSectionMixin } from '../../../mixins/GetLayoutSection'
import DialogTicket from '../DialogTicket.vue'

export default {
  mixins: [GetLayoutSectionMixin],
  components: {
    DialogTicket
  },
  props: {
    settings: {type: Object},
    splitArray: {type: Array},
    openCheckout: {type: Function}
  },

  computed: {
    ...mapGetters(["products", "oneCheckoutOpen", "infos", "tickets", "productErrorMessage"]),
  },

  data: () => ({
    alignHorizontal: true
  })
}
</script>

<style scoped>
.description {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0px;
  /* text-align: left; */
}

.price {
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: 0.25px;
  text-align: right;
}  
</style>